import {Tag} from "antd";
import styled, {keyframes} from "styled-components";

const popForward = keyframes`
    0%, 60%, 100% {
        transform: rotate(0deg);
        z-index: 1;
    }
    20% {
        transform: rotate(-2deg);
        z-index: 10;
    }
    35% {
        transform: rotate(2deg);
        z-index: 10;
    }
    50% {
        transform: rotate(0deg);
        z-index: 10;
    }
`;

export const PoppingTag = styled(Tag)`
    position: relative;
    display: inline-block;
    transform-origin: center;
    backface-visibility: hidden;
    will-change: transform;
    animation: ${popForward} 0.75s ease-in-out infinite;
`;
